/* eslint-disable no-unused-vars */
import debugFactory from "debug";
import { clientIdentifier, listenTo } from "@teaming/io-helpers";
import { SocketMessageType } from "@teaming/common-enums";

export function configureSockets( { storeName, store, navigation, ioSocket, ioTeam, ioStream, alerts, } ) {
	const debug = debugFactory( `teaming:common-team:stores:${ storeName }:sockets` );

	[
		SocketMessageType.STREAM_SUBDOC_UPDATED,
	].forEach( async socketEvent => {
		debug( `adding socket listener: ${ storeName } <= ${ socketEvent }` );
		ioSocket.addSocketMessageListener( socketEvent, async message => {
			const { body, clientIdentifier: messageClientIdentifier, } = message;
			debug( "received transcription update message", { body, } );

			const { documentName, subDocId, } = body;

			const response = await ioStream.fetchSubDocSupplement( {
				documentName,
				subDocId,
			}, {
				withSummary: true,
			} );
			const { summary, recurrenceInfo } = response.data;

			store.commit( `${ storeName }/receiveTranscriptionSummaries`, [ summary, ] );
			store.commit( `${ storeName }/receiveRecurrenceInfos`, [ recurrenceInfo, ] );
		} );
	} );

	[
		SocketMessageType.STREAM_RECURRENCE_UPDATED,
	].forEach( async socketEvent => {
		debug( `adding socket listener: ${ storeName } <= ${ socketEvent }` );
		ioSocket.addSocketMessageListener( socketEvent, async message => {
			const { body, clientIdentifier: messageClientIdentifier, } = message;
			debug( "received recurrence update message", { body, } );

			const { documentName, } = body;

			const { data, } = await ioStream.fetchRecurrences( { documentName, } );

			// recurrencesResponse.data contains both recurrences and one-time meetings
			// filter these based on isOneTime flag
			const recurrences = data.filter( recurrence => !recurrence.isOneTime );
			const oneTimeMeetings = data.filter( recurrence => recurrence.isOneTime );
			store.commit( `${ storeName }/receiveRecurrences`, { recurrences, } );
			store.commit( `${ storeName }/receiveOneTimeMeetings`, { oneTimeMeetings, } );
		} );
	} );
}

export function configureChannels( { storeName, store, navigation, ioChannel, ioMeeting, alerts, } ) {
	const debug = debugFactory( `teaming:common-team:stores:${ storeName }:channels` );
}
